import React from 'react';

import { Container } from './styles';

const Panel: React.FC = () => {
  return (
    <>
      <Container />
    </>
  );
};

export default Panel;
